import React from 'react';
// components
import DateColumn from 'refactored/features/emergencies/ui/columns/date-column';
import DateRow from 'refactored/features/emergencies/ui/rows/date-row';
import DateText from 'refactored/features/emergencies/ui/texts/DateText';

const TicketsListTableDateRow = ({ ticketsGroupedByDay }) => {
  return (
    <DateRow key={ticketsGroupedByDay.label}>
      <DateColumn>
        <DateText>
          {ticketsGroupedByDay.label} ({ticketsGroupedByDay.tickets.length}{' '}
          tickets)
        </DateText>
      </DateColumn>
    </DateRow>
  );
};

export default TicketsListTableDateRow;
